export const sponsorsListStyle = {
	title: {
		color: 'var(--neutral-300)',
		fontWeight: 700,
		marginBottom: '8px',
		textTransform: 'capitalize',
	},

	content: {
		display: 'flex',
		gap: '20px',
		flexWrap: 'wrap',
		marginBottom: '12px',

		'@media (max-width: 639.98px)': {
			gap: '12px',
			// justifyContent: 'center',
		},
	},

	sponsor: {
		maxWidth: '145px',
		width: '100%',
		height: '144px',
		position: 'relative',

		'@media (max-width: 639.98px)': {
			maxWidth: 'calc(50% - 6px)',
			flex: '1 1 calc(50% - 6px)',
		},
	},

	sponsorImage: {
		maxHeight: '104px',
		height: '100%',
		overflow: 'hidden',
		borderRadius: '8px 8px 0 0',
		'& img': {
			objectFit: 'cover',
			height: '100%',
			width: '100%',
		},
	},

	sponsorName: {
		height: '40px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		fontSize: '14px',
		borderRadius: '0px 0px 8px 8px',
		boxShadow: ' 0px 4px 16px 0px rgba(40, 103, 131, 0.06)',
	},

	dropdown: {
		position: 'absolute',
		right: '4px',
		top: '4px',
		cursor: 'pointer',
	},

	dropdownIcon: {
		'svg path': {
			fill: 'var(--primary-500)',
		},
	},

	dropdownOption: {
		padding: '8px 16px',
		maxWidth: '160px',
		width: '160px',
		textTransform: 'capitalize',
		cursor: 'pointer',
	},

	modal: {
		'.MuiPaper-root': {
			maxWidth: '770px',
			padding: '48px 200px',
			width: '100%',
			'@media (max-width: 1199.98px)': {
				padding: '32px 48px',
			},
			'@media (max-width: 639.98px)': {
				padding: '24px 16px',
			},
		},
	},
};
